<div>
	@if (rotor) {
	<div class="row">
		<label class="col-md-2 col-form-label-sm">Operation:</label>
		<div class="col-md-6">
			@if (operations !== undefined) {
			<select class="form-control form-control-sm op-list" [(ngModel)]="operation" (ngModelChange)="refreshRegimeCounts()"
				title="Only showing {{ operations && operations.length >= RECENT_OPERATIONS_LIMIT ? 'latest ' + RECENT_OPERATIONS_LIMIT + ' ' : '' }}operations with track data for rotor '{{rotor.rotorid}}'">
				@for (operation of operations; track operation) {
				<option [ngValue]="operation" [class]="GetOpClass(operation)">
					{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
					runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}{{operation.exceedance_count > 0 ? "
					Ex: " + operation.exceedance_count : ""}}
				</option>
				}
			</select>
			}
			@if (operations === undefined) {
			<select class="form-control form-control-sm" disabled>
				<option>Loading Track operations...</option>
			</select>
			}
		</div>
	</div>
	}

	@if (regimeCounts !== undefined && regimeCounts.length === 0) {
	<div class="loading-status">
		No track data is available for the selected operation
	</div>
	}

	@if (operations && operations.length > 0 && regimeCounts === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading track operations...
	</div>
	}

	@if (operations && operations.length === 0) {
	<div class="loading-status">
		No operations with track data are available
	</div>
	}

	@if (regimeCounts !== undefined && regimeCounts.length > 0) {
	<div class="row">
		<div class="col-lg-5">
			<div class="panel constrain">
				<div class="heading">Regimes</div>
				<div class="content nopad">
					<table class="log openborders paneled regimes">
						<thead>
							<tr>
								<th># Acq</th>
								<th>Regime</th>
								<th>Eval</th>
								<th>Split ({{rotor.inches ? "in" : "mm"}})</th>
								<th>Pred ({{rotor.inches ? "in" : "mm"}})</th>
							</tr>
						</thead>
						@for (regime of regimeCounts; track regime) {
						<tbody class="regime">
							<td>{{regime.count}}</td>
							<td>{{regime.name}}</td>
							<td>
								<input type="checkbox" [(ngModel)]="regime.evaluate" (ngModelChange)="regimesChange()">
							</td>
							<td>
								@if (regimeSplit) {
								<span>{{regimeSplit[regime.regime_id]?.split | number : (rotor.inches ? "1.0-2" : "1.0-1")}}</span>
								}
							</td>
							<td>
								@if (regimeSplit) {
								<span>{{regimeSplit[regime.regime_id]?.predsplit | number : (rotor.inches ? "1.0-2" : "1.0-1")}}</span>
								}
							</td>
						</tbody>
						}
					</table>
				</div>
			</div>
			@if (rotor.balancedata && rotor.balancedata.numblades >= 4 && !rotor.balancedata.oneperrev) {
			<div class="row mt-2">
				<div class="col-4">
					1/rev Only
				</div>
				<div class="col-8">
					<div class="form-check form-check-inline">
						<label>
							<input type="checkbox" [(ngModel)]="onePerRevOnly" (ngModelChange)="updatePlot()">
						</label>
					</div>
				</div>
			</div>
			}
			@if (selectedRegimes && selectedRegimes.length) {
			<div class="panel mt-3">
				<div class="heading">Adjustments</div>
				<div class="content">
					<table class="adjustments">
						<tr>
							<th></th>
							<!-- Note: configs with extra blades in displaygroups are "guaranteed" to not use track -->
							@for (blade of ReorderBlades(rotor.blade); track blade) {
							<th>{{blade.name}}</th>
							}
							<th></th>
						</tr>
						@for (adjdef of rotor.adjdef; track adjdef; let i = $index) {
						<!-- Hardcoded exclude 'WTS' adjdef for track -->
						@if (adjdef.name !== 'WTS') {
						<tr>
							<th>
								<a [hidden]="!alternates || !alternates[i].length" (click)="adjDetail[i] = !adjDetail[i]" href="javascript:void(0)" class="nowrap">{{ adjdef.name }} &#9662;</a>
								<span [hidden]="alternates && alternates[i].length">{{ adjdef.name }}:</span>
							</th>
							@for (blade of rotor.blade; track blade; let j = $index) {
							<td>
								@if (adjustments) {
								<input [(ngModel)]="adjustments[i][j]" (keyup.enter)="ManualAdjustment()" type="number" class="adj-entry">
								}
							</td>
							}
							<th>
								<input [(ngModel)]="adjustmentSelect[i]" type="checkbox" (ngModelChange)="updatePlot()">
							</th>
						</tr>
						@if (alternates) {
						@for (alt of alternates[i]; track alt; let altIdx = $index) {
						<tr (click)="SetAdjustment(i, altIdx)" [hidden]="!adjDetail[i]" class="alt-row">
							<th></th>
							@for (blade of rotor.blade; track blade; let j = $index) {
							<td>
								@if (adjustments) {
								<div>{{alt[j] | number : "1.0-1"}}</div>
								}
							</td>
							}
							<th></th>
						</tr>
						}
						}
						<tr class="divider">
							<th></th>
						</tr>
						}
						}
					</table>
					<button (click)="RecordAdjustment()" class="button block">Record adjustment</button>
				</div>
			</div>
			}
		</div>
		<div class="col-lg-7">
			<app-dvs-chart [error]="errormessage" [options]="trackOptions" loading="Loading track data..." [height]="'400px'"></app-dvs-chart>
			@if (trackOptions) {
			<div class="chart-legend">
				<span class="legend-item">
					<span class="swatch square"></span> Averages
				</span>
				<span class="legend-item">
					<span class="swatch diamond"></span> Predictions
				</span>
			</div>
			}
		</div>
	</div>
	}
</div>